module.exports = __webpack_public_path__ + "img/up.623478d.png";